export type List_TipiSegnalazioneObject = {
	Id: string;
	Picklist_Padre__c: string;
	Picklist_Figlia__c: string;
	Valore_Padre__c: string;
	Valore_Figlia__c: string;
	testo_mostrato__c: string | null;
	Ente__c: string | null;
	Allegato_Obbligatorio__c: boolean;
};

export type List_EntiObject = {
	Id: string;
	flagAbilitaPagaComodo__c: boolean;
	flagAbilitato__c: boolean;
	idDescrizioneEntePortale__c: string;
	idEnteSistemaRemoto__c: string;
	idSistemaRemoto__c: string;
	Name: string;
	Id_Ente__c: string;
	ente: string;
	Ente__c: string;
};
export type EntiObject = {
	Ente__c: string;
	Provincia__c: string;
};

export type List_EntiPerCategoriaObject = {
	Ente__c: string;
	idDescrizioneEntePortale__c: string;
	Id_Ente__c?: string;
	formati?: FormatoManifesto[];
	parcheggi?: ParcheggioEnte[];
	articoli?: ArticoloParcheggio[];
	sportello_comune?: string | null;
};


export type EnteGES = {
	codice: string;
	descrizione: string;
	idEnteGES: number;
};

export type ServizoPerEntePagamento = {
	codiceErrore: string;
	codiceServizioGES: string;
	descrizione: string;
	esitoOperazione: string;

	idContrattoPagoPA: number;
	isMultibeneficiario: boolean;
	note: string;
	percTEFA: string;
};
// export type List_ServiziPerEntePagamento = {
// 	ServizoPerEntePagamento[];
// };


export type FormatoManifesto = {
	idCategoriaMezzo: string;
	codice: string;
	formato: string;
	idEnte: string;
	descrizioneEnte: string;
};

export type ParcheggioEnte = {
	idParcheggio: number;
	codice: string;
	descrizione: string;
	idEnte: number;
	descrizioneEnte: string;
	categoriaRendicontazione: string;
	centroCosto: string;
	fatturazioneAttiva: string;
	percIncassoCorrispettivi: number;
};

export type ArticoloParcheggio = {
	idArticolo: number;
	codice: string;
	descrizione: string;
	idParcheggio: number;
	descrizioneParcheggio: string;
	idEnte: number;
	descrizioneEnte: string;
	categoriaPortaleContribuente: string;
	prezzo: number;
	codiceAliquotaIVA: string;
	descrizioneAliquotaIVA: string;
	dataInizioValidita: string;
	dataFineValidita: string;
	richiedeLotto: string;
	richiedePeriodo: string;
	richiedeTarga: string;
	valoreModificabileSuDocumento: string;
	gestibileSoloUfficioCentrale: string;
	moltiplicatorePortaleContribuente: number;
};

export const enum LISTA_CATEGORIE_ENTE_CATEGORIA {
	ILLUMINAZIONE_VOTIVA = 'SF500',
	SEGNALAZIONE_ILLUMINAZIONE_VOTIVA = 'SF510',
	PUBBLICITA_E_PUBBLICHE_AFFISSIONI = 'SF120',
	LOCANDINE = 'SF150',

	NUOVO_MEZZO_PUBBLICITARIO = 'SF100',
	VARIAZIONE_CESSAZIONE_MEZZO_PUBBLICITARIO = 'SF110',
	SEGNALAZIONE_PUBBLICITA = 'SF130',
	SEGNALAZIONE_MOBILITY = 'SF310',
	NUOVO_ABBONAMNETO_PARCHEGGI = 'SF300',
	RICHIESTA_RATEIZZAZIONE = 'SF200',
	RICHIESTA_RINEGOZIAZIONE_PAGAMENTO = 'SF210',
	FUNZIONE_RICHIESTA_RIESAME_PRATICA = 'SF220',
	SEGNALAZIONE_RECUPERO_CREDITI = 'SF230',
	SEGNALAZIONE_RIFIUTI = 'SF410',
	SEGNALAZIONE_OCCUPAZIONE_SUOLO = 'SF140',
	SEGNALAZIONE_IMMOBILI = 'SF420',
	SEGNALAZIONE_IMPOSTA_SOGGIORNO = 'SF630',
	DELEGA_IMPOSTA_SOGGIORNO = 'SF610',
	ABILITAZIONE_STRUTTURA_RICETTIVA = 'SF620',
}

export type List_PosizioniObject = {
	idPosizione: string;
	dataEmissioneDoc: string;
	descrizioneTipoDocumento: string;
	Id: string;
	anno: number;
	descrizioneTipoDocumento__c: string;
	nomeEnte: string | null;
	Name: string;
	OwnerId: string;
	Tipo__c: string | null;
	Stato__c: boolean;
	Account__c: string;
	CreatedDate: string;
	Posizione__c: string;
	NumeroDoc__c: string;
	LastViewedDate: string;
	Codice_Utente__c: string;
	LastReferencedDate: string;
	Data_Cessazione__c: string | null;
	DataEmissioneDoc__c: string;
	Codice_Controllo__c: string;
	areaTematica: string | null;
	Posizione__r: {
		Id: string;
		Codice_Ente__c: string | null;
		Anno__c: number;
		Contribuente__c: string;
		Contribuente__r: {
			Id: string;
			Name: string;
			ragione_Sociale__c: string;
			codiceUtenteSistema__c: string;
			idAnagraficaUtenteSistema__c: string;
		};
		Id_Ente__c: string | null;
		Idposizione__c: string;
		Nome_Ente__c: string | null;
		sistema__c: string;
		descrizioneTipoDocumento__c: string;
		dataEmissioneDoc__c: string;
		CreatedDate: string;
		ws_codice: string;
		idSistemaRemoto__c: string|null;
	};
	NomeServizio: string;
	listaEnti: Array<List_PosizioniObject_ListaEnti>;
	idDescrizioneEntePortale__c: string | null;
};

export type List_PosizioniObject_ListaEnti = {
	ente: string;
	descrEnte: string;
};

export type List_Documenti = {
	idDocumento: string;
	anno: number;
	codiceTipoDocumento?: string;
	dataEmissione: string;
	dataNotifica: string;
	dataScadenza: string;
	dataArchiviazione: string;
	descrTipoDocumento: string;
	flagCategoriaDoc: boolean;
	flagRateizzazioneCRC2: boolean;
	codiceEnteGES: string;
	codiceFiscaleEnteCreditoreGES: string;
	codiceServizioGES: string;
	descrEnte: string;
	flagPagoPA: boolean;
	flagRateizza: string;
	flagRichiestaProrogaPianoRate: boolean;
	flagRichiestaRateizzazione: boolean;
	flagRichiestaIstanzaRiesame: boolean;
	flagTipoEntrata: string;
	importo: string;
	importoPagato: string;
	notaPortale: string;
	numero: number;
	numeroCC: string;
	tipoPagamento: string;
	scadenze: List_Documenti_Scadenze;
	idDocSpedizione: string;
	numeroEnte: string;
	identificativoCoattiva: string;
	tipoBollettino: string;
	posizione_doc: {
		idPosizione: string;
		anno: number | null;
		codiceErrore: string | null;
		codiceEnte: string;
		codiceUtente: string;
		dataEmissioneDoc: string | null;
		descrErrore: string | null;
		descrizioneTipoDocumento: string | null;
		esito: string | null;
		idAnagraficaUtente: string;
		idEnte: string;
		nomeEnte: string;
		numeroDoc: string | null;
		ragioneSociale: string;
	},
	codice_utente: string;
	codice_controllo: string;
}[];

type List_Documenti_Scadenze = {
	IUVPagoPA: string;
	dataScadenza: string;
	identificativo: string;
	importoDovuto: number;
	importoPagato: number;
	numeroAvvisoPagoPA: string;
	numeroRata: string;
	residuo: string;
	statoPagamento: string;
}[];

type Posizione_Doc = {
	anno: number;
	codiceErrore: string;
	codiceEnte: string;
	codiceUtente: string;
	dataEmissioneDoc: string;
	descrErrore: string;
	descrizioneTipoDocumento: string;
	esito: string;
	idAnagraficaUtente: number;
	idEnte: number;
	idPosizione: number;
	nomeEnte: string;
	numeroDoc: string;
	ragioneSociale: string;
}

export type List_DichiarazioniObject = {
	Id: string;
	Nome_Ente: string;
	Ente__c: {
		Id: string;
		Name: string;
		Id_Ente__c: string;
	};
	RecordTypeId: string;
	RecordTypeName: string;
	Tipo__c: string;
	Stato_Dichiarazione__c: string;
	CreatedDate: string;
	Servizio__c: string;
	Tipo_Segnalazione__c: string;
	Motivazione_Segnalazione__c: string;
	Stato_Segnalazione__c: string;
	Descrizione_Segnalazione__c: string;
	Email__c: string;
};

export type List_DocumentiDaVerificare = {
	idPosizione: string | null;
	codiceFiscale: string;
	dataEmissioneDoc: string;
	descrizioneTipoDocumento: string;
	nomeEnte: string | null;
	anno: number | null;
	ws_codice: string | null;
	Posizione__r: {
		Codice_Ente__c: string | null;
		Id_Ente__c: string | null;
		descrizioneTipoDocumento__c: string;
		Contribuente__r: {
			Name: string | null;
			ragione_Sociale__c: string;
			codiceUtenteSistema__c: string | null;
			idAnagraficaUtenteSistema__c: string | null;
		};
		sistema__c: string | null;
	};
	documenti: Array<{
		idDocumento: string;
		anno: number;
		codiceTipoDocumento: string;
		dataEmissione: string;
		dataNotifica: string;
		dataScadenza: string;
		dataArchiviazione: string;
		descrTipoDocumento: string;
		flagCategoriaDoc: boolean;
		flagRateizzazioneCRC2: boolean;
		flagRichiestaProrogaPianoRate: boolean;
		flagRichiestaRateizzazione: boolean;
		flagRichiestaIstanzaRiesame: boolean;
		flagTipoEntrata: string;
		flagRateizza: string;
		idDocSpedizione: string;
		importo: string;
		importoPagato: string;
		numero: number;
		numeroEnte: string;
		tipoPagamento: string;
		identificativoCoattiva: string;
	}>;
	codice_utente: string;
	codice_controllo: string;
};

export type List_DocRateizzaProrogaRiesamina = {
	codiceUtente: string;
	codiceControllo: string;
	nomeEnte: string;
	documentiDaVerificare: List_DocumentiDaVerificare;
};

export type List_SegnalazioniObject = {
	Id: string;
	Descrizione_Segnalazione__c: string;
	Motivazione_Segnalazione__c: string;
	Stato_Dichiarazione__c: string;
	Stato_Segnalazione__c: string;
	Tipo_Segnalazione__c: string;
	RecordTypeId: string;
	CreatedDate: string;
	Servizio__c: string;
	Account__c: string;
	Email__c: string;
	Note__c: string;
	Tipo__c: string;
	Commenti: [
		{
			Id: string;
			Descrizione__c: string;
			CreatoDalPortale__c: string;
			CreatedDate: string;
			Documents: [
				{
					Id: string;
					Titolo__c: string;
					Download_url: string;
					FileExtension: string;
				}
			];
		}
	];
	Documents: [
		{
			Id: string;
			Titolo__c: string;
			Download_url: string;
			FileExtension: string;
		}
	];
};

type LabelObject = {
	label: string;
};

export type List_TombePickListObject = {
	[key: string]: LabelObject;
};

export type List_RiesamePickListObject = {
	[key: string]: LabelObject;
};

export enum TipoQualifica {
	'Titolare di ditta individuale' = 'Titolare di ditta individuale',
	'Legale rappresentante' = 'Legale rappresentante',
	'Tutore' = 'Tutore',
	'Curatore' = 'Curatore',
	'Altro' = 'Altro',
}
export const ListaTipoQualifica: Array<TipoQualifica> = [
	TipoQualifica['Titolare di ditta individuale'],
	TipoQualifica['Legale rappresentante'],
	TipoQualifica['Tutore'],
	TipoQualifica['Curatore'],
	TipoQualifica['Altro'],
];

export const List_DecodificaServizio: { [key: string]: string } = {
	ICPMB: 'affissione manifesti',
	ICP: 'affissione manifesti',
	CRC: 'recupero crediti',
	CRC2: 'recupero crediti',
	"CRC 2.0": 'recupero crediti',
	TARMB: 'rifiuti TARI',
	'Rifiuti TARI': 'rifiuti TARI',
	PAR: 'parcheggi',
	OSAP: 'occupazione suolo pubblico',
	COSMB: 'occupazione suolo pubblico',
};
